import { sb, roleOf, roleColor, roleLabel } from '../../../workspace-project/functions/index.js'

const _headerRow = {
  display: 'grid',
  gridTemplateColumns: '2fr 1fr auto',
  gap: 'Z',
  padding: 'Z A',
  borderBottomWidth: '2px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'line',
  childProps: {
    fontSize: 'Y1',
    fontWeight: '700',
    letterSpacing: '.04em',
    textTransform: 'uppercase',
    color: 'caption'
  },
  H01: { text: 'Name' },
  H02: { text: 'Role' },
  H03: { text: '', width: 'C2' }
}

const _userRow = {
  display: 'grid',
  gridTemplateColumns: '2fr 1fr auto',
  gap: 'Z',
  align: 'center',
  padding: 'Z1 A',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'line',
  ':hover': { background: 'overlayStrong' },

  Left: {
    flow: 'x',
    align: 'center',
    gap: 'Z1',
    minWidth: '0',

    Avatar: {
      align: 'center center',
      width: 'B1',
      height: 'B1',
      round: '50%',
      color: 'white',
      fontSize: 'Z',
      fontWeight: '700',
      background: 'blue',
      text: (el, s) => s.avatar || ''
    },
    Info: {
      flow: 'y',
      gap: 'V',
      flex: '1',
      minWidth: '0',
      Name: { tag: 'span', fontSize: 'A', fontWeight: '600', color: 'title', text: (el, s) => s.name },
      Email: { tag: 'span', fontSize: 'Z2', color: 'caption', text: (el, s) => s.email }
    }
  },

  RoleBadge: {
    tag: 'span',
    padding: 'V Z1',
    round: 'Y',
    alignSelf: 'center',
    justifySelf: 'flex-start',
    width: 'fit-content',
    background: (el, s) => roleColor(s, s.userId ? (roleOf(s, s.userId) || 'member') : 'member'),
    color: 'white',
    fontSize: 'Z2',
    fontWeight: '700',
    text: (el, s) => {
      // eslint-disable-next-line no-unused-expressions
      s.root.roles && s.root.roles.version
      const cur = s.userId ? (roleOf(s, s.userId) || 'member') : 'member'
      return roleLabel(s, cur)
    }
  },

  EditBtn: {
    tag: 'button',
    text: 'Edit',
    width: 'C2',
    padding: 'V Z1',
    round: 'Y',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    background: 'transparent',
    color: 'title',
    cursor: 'pointer',
    fontSize: 'Z2',
    alignSelf: 'center',
    ':hover': { background: 'overlay' },
    onClick: (e, el, s) => {
      if (!s.email) return
      const root = el.call('findRouteRoot', el)
      if (root) el.router(`/profile?u=${encodeURIComponent(s.email)}`, root)
    }
  }
}

export const admin = {
  extends: 'AppPage',
  metadata: { title: 'Admin / Symbols Workspace' },
  onInit: (el, s) => {
    if (!el.call('shouldRedirectNoPerm', s, 'admin.pages.read')) return
    const root = el.call('findRouteRoot', el)
    if (root) el.router('/', root, {}, { pushState: true })
  },

  AdminSidebar: {},

  AdminMain: {
    extends: 'AppMain',
    padding: '0',
    Header: { extends: 'PageHeader', LeftGroup: { Title: { text: 'Users & Roles' } } },

    Body: {
      overflow: 'auto',
      padding: 'B',
      flow: 'y',
      gap: 'B',

      RoleGroups: {
        flow: 'y',
        gap: 'B',
        childExtends: {
          flow: 'y',
          round: 'Z2',
          background: 'overlay',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'line',
          padding: 'A',

          GroupTitle: {
            flow: 'x',
            align: 'center space-between',
            margin: '0 0 Z 0',
            GroupName: {
              flow: 'x',
              align: 'center',
              gap: 'Z',
              H2: { tag: 'h2', fontSize: 'B', fontWeight: '800', color: 'title', margin: '0', text: (el, s) => s.name },
              Badge: {
                tag: 'span',
                padding: 'V Z',
                round: 'Y',
                fontSize: 'Y1',
                fontWeight: '700',
                color: 'caption',
                background: 'overlayStrong',
                text: (el, s) => String((s.people || []).length)
              }
            }
          },

          GroupHeader: _headerRow,

          GroupList: {
            flow: 'y',
            childExtends: _userRow,
            childrenAs: 'state',
            children: (el, s) => s.people || []
          }
        },
        childrenAs: 'state',
        children: (el, s) => {
          // eslint-disable-next-line no-unused-expressions
          s.root.roles && s.root.roles.version
          return el.call('groupFilteredPeople')
        }
      }
    }
  }
}

// ── Admin sidebar (shared across all admin pages) ──
export const AdminSidebar = {
  extends: 'AppSidebar',
  PeopleSection: null,
  width: 'G',
  minWidth: 'G',

  Top: null,

  Middle: {
    flow: 'y', gap: 'V',
    childExtends: 'AdminSidebarLink',
    childrenAs: 'state',
    children: () => [
      { label: 'Users & Roles', href: '/admin' },
      { label: 'Teams & Permissions', href: '/admin/teams' },
      { label: 'Permissions Overview', href: '/admin/permissions' },
      { label: 'Cap Table', href: '/admin/cap-table' },
      { label: 'Activity Scoring', href: '/admin/activity-scoring' },
      { label: 'Activity Logs', href: '/admin/logs' },
      { label: 'Integrations', href: '/admin/integrations' },
      { label: 'External data', href: '/data/external' },
      { label: 'Status', href: '/admin/status' },
      { label: 'Danger Zone', href: '/admin/danger' }
    ]
  }
}

// ── Sidebar link ──
export const AdminSidebarLink = {
  extends: 'Link',
  Label: { text: (el, s) => s.label || '' },
  padding: 'Z A',
  round: 'Z',
  fontSize: 'A',
  textDecoration: 'none',
  cursor: 'pointer',
  href: (el, s) => s.href,
  background: (el, s) => (s.root?.currentPath || '/') === s.href ? 'overlay' : 'transparent',
  color: (el, s) => (s.root?.currentPath || '/') === s.href ? 'title' : 'subtitle'
}

// Backward compat export
export const AdminUserRow = _userRow
